var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.889,
    height: 14,
    viewBox: "0 0 10.889 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete",
    "data-name": "Icon material-delete",
    d: "M8.278,16.944A1.56,1.56,0,0,0,9.833,18.5h6.222a1.56,1.56,0,0,0,1.556-1.556V7.611H8.278ZM18.389,5.278H15.667L14.889,4.5H11l-.778.778H7.5V6.833H18.389Z",
    transform: "translate(-7.5 -4.5)",
    fill: "#CB3D47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/delete_red.a691065711e9222f434ce85f823ead1b.svg";
export { ForwardRef as ReactComponent };